module.exports = __webpack_public_path__ + "static/media/landingPageBG-desktop.4aeaa59d.jpg";